import { useEffect } from 'react';
import { useSave } from '@rlean/core';
import { ActivePage } from 'lib/entities';

export default function useActivePage(page) {
  const [save] = useSave();

  useEffect(() => {
    let isSubscribed = true;

    if (isSubscribed) {
      save({ entity: ActivePage, value: page });
    }

    return () => {
      isSubscribed = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
}
